import { RM01 } from "./RM01";
import { RM03 } from "./RM03";
import { RM05 } from "./RM05";
import { RM06 } from "./RM06";

export const RegionCoverageReport = {
  sections: [
    RM06, 
    RM01, 
  ],
};
